import { createContext, useContext } from 'react';

const BulkEditContext = createContext(false);

export const BulkEditProvider = BulkEditContext.Provider;

export const useIsBulkEdit = () => useContext(BulkEditContext);
